import { Box, Button, Paper, Typography } from '@mui/material';
import React from 'react';
import { i18n } from '../../translate/i18n';
import VideoIcon from '../../assets/VideoIcon.svg';

const NotionCard = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        display: "flex",
        padding: "4px 20px",
        justifyContent: "space-between",
        alignItems: "center",
        alignSelf: "stretch",
        borderRadius: "8px",
        border: "1px solid #E0E0E0",
        backgroundColor: "#FFF",
        marginBottom: "16px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "2px",
        }}
      >
        <Box sx={{ color: "#2554c7" }}>
          <img src={VideoIcon} alt="Video Icon" width="113px" height="113px" />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
            gap: "4px",
            alignSelf: "stretch",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontSize: "20px",
              fontWeight: 700,
              lineHeight: "160%",
              color: "rgba(16, 24, 32, 0.60)",
            }}
          >
            {i18n.t('notionCard.notionTitle')}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontSize: "14px",
              fontWeight: 400,
              lineHeight: "143%",
              color: "rgba(16, 24, 32, 0.60)",
            }}
          >
            {i18n.t("notionCard.notionDescription")}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button
          variant="outlined"
          onClick={() => window.open('https://sistemasgap.notion.site/Manuais-Software-GEEQUIP-1bb15dfe28ec80129757ccfeb35a93b0', '_blank')}
        >
          {i18n.t("notionCard.notionLink")}
        </Button>
      </Box>
    </Paper>
  )
};

export default NotionCard;